<kendo-grid
  #grid
  [navigable]="true"
  [resizable]="true"
  [data]="gridData"
  (remove)="removeRow($event)"
  >
  <kendo-grid-column
    field="accountUid"
    title="{{ 'account' | translate}}"
    [width]="wEGrid.account"
    [minResizableWidth]="wEGrid.account"
    >
    <ng-template
      kendoGridCellTemplate
      let-dataItem
      let-rowIndex="rowIndex"
      let-column="column"
      >
      <kendo-multicolumncombobox
        required
        #accountsDropdown
        appInfiniteScroll
        [data]="accounts"
        [textField]="'fullName'"
        [valueField]="'uid'"
        [valuePrimitive]="true"
        [filterable]="true"
        [allowCustom]="false"
        [popupSettings]="{
          appendTo: 'component'
        }"
        (focus)="onAccountsDropdownFocus(accountsDropdown)"
        [formControl]="getFormControl(dataItem, column.field)"
        (filterChange)="onAccountsFilterChange($event)"
        (valueChange)="onAccountsValueChange($event, dataItem)"
        >
        <kendo-combobox-column [field]="'code'" [title]="'Code'" [width]="60">
          <ng-template kendoMultiColumnComboBoxColumnCellTemplate let-dataItem>
            <span style="white-space: pre !important">{{ dataItem?.code }}</span>
          </ng-template>
        </kendo-combobox-column>
        <kendo-combobox-column [field]="'name'" [title]="'Name'" [width]="90">
          <ng-template kendoMultiColumnComboBoxColumnCellTemplate let-dataItem>
            {{ dataItem?.name }}
          </ng-template>
        </kendo-combobox-column>
        <ng-template kendoMultiColumnComboBoxNoDataTemplate>
          <div>
            {{ 'noDataFound' | translate}} <br />
            @if (customValue) {
              <button
                kendoButton
                [primary]="true"
                (click)="createAccount(customValue,rowIndex)"
                >
                Create "{{ customValue }}"
              </button>
            }
          </div>
        </ng-template>
      </kendo-multicolumncombobox>
    </ng-template>
    <ng-template kendoGridFooterTemplate> {{ 'total' | translate}} </ng-template>
  </kendo-grid-column>
  <kendo-grid-column
    field="remark"
    title="{{ 'note' | translate}}"
    class="auto-col"
    headerClass="auto-col"
    footerClass="auto-col"
    [minResizableWidth]="wEGrid.textS"
    >
    <ng-template
      kendoGridCellTemplate
      let-dataItem
      let-rowIndex="rowIndex"
      let-column="column"
      >
      <input
        class="k-textbox"
        maxlength="255"
        [formControl]="getFormControl(dataItem, column.field)"
        />
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column
      field="budgetSheetItemUid"
      title="Budget Item"
      [width]="180"
      [minResizableWidth]="140"
      [hidden]="budgetItems.length === 0"
      >
      <ng-template
        kendoGridCellTemplate
        let-dataItem
        let-rowIndex="rowIndex"
        let-column="column"
        >
        <kendo-combobox
          #budgetItemDropdown
          [data]="budgetItems"
          [textField]="'itemName'"
          [valueField]="'uid'"
          [valuePrimitive]="true"
          [filterable]="true"
          [formControl]="getFormControl(dataItem, column.field)"
          [popupSettings]="{ appendTo: 'root', width: 250 }"
          (focus)="budgetItemDropdown.toggle(true)"
          >
        </kendo-combobox>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column
      field="amount"
      title="{{ 'amount' | translate}}"
      class="text-end"
      [width]="wEGrid.totalPrice"
      [minResizableWidth]="wEGrid.totalPrice"
      >
      <ng-template
        kendoGridCellTemplate
        let-dataItem
        let-rowIndex="rowIndex"
        let-column="column"
        >
        <kendo-numerictextbox
          #amountTextbox
          [spinners]="false"
          [min]="0"
          [autoCorrect]="true"
          [decimals]="2"
          [formControl]="getFormControl(dataItem, column.field)"
        ></kendo-numerictextbox>
      </ng-template>
      <ng-template kendoGridFooterTemplate>
        <div class="numeric-column-footer">
          <app-currency-total
            [currencyUid]="parentForm.controls.currencyUid.value"
            [totalAmount]="totalAmount"
          ></app-currency-total>
        </div>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column
      [hidden]="isMonoCurrency"
      field="currency"
      title="{{ 'currency' | translate}}"
      [width]="wEGrid.currency"
      [minResizableWidth]="wEGrid.currency"
      >
      <ng-template
        kendoGridCellTemplate
        let-dataItem
        let-rowIndex="rowIndex"
        let-column="column"
        >
        <kendo-multicolumncombobox
          #currenciesDropdown
          [data]="currencies"
          [textField]="'name'"
          [valueField]="'uid'"
          [valuePrimitive]="true"
          [filterable]="true"
          [allowCustom]="false"
          [formControl]="getFormControl(dataItem, column.field)"
          (valueChange)="onCurrencyValueChange($event, dataItem)"
          >
          <kendo-combobox-column [field]="'symbol'" [title]="'Symbol'">
            <ng-template kendoMultiColumnComboBoxColumnCellTemplate let-dataItem>
              {{ dataItem?.symbol }}
            </ng-template>
          </kendo-combobox-column>
          <kendo-combobox-column [field]="'name'" [title]="'Name'">
            <ng-template kendoMultiColumnComboBoxColumnCellTemplate let-dataItem>
              {{ dataItem?.name }}
            </ng-template>
          </kendo-combobox-column>
        </kendo-multicolumncombobox>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column
      [hidden]="true"
      field="rate"
      title="{{ 'rate' | translate}}"
      [width]="wEGrid.textL"
      [minResizableWidth]="wEGrid.textL"
      >
      <ng-template
        kendoGridCellTemplate
        let-dataItem
        let-rowIndex="rowIndex"
        let-column="column"
        >
        <div class="flex flex-row gap-4">
          <kendo-numerictextbox
            class="basis-[45%]"
            #rateTextboxes
            [spinners]="false"
            [min]="0"
            [decimals]="8"
            format="#.########"
            [formControl]="getFormControl(dataItem, column.field)"
          ></kendo-numerictextbox>
          <span class="basis-[30%]" #rateLabels style="font-size: 12px"></span>
          <button
            class="basis-[12.5%]"
            [disabled]="disabledMode === 'yes'"
            icon="plus-circle"
            kendoButton
            #fetchButton
            (click)="fetchRate(dataItem)"
          ></button>
        </div>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column
      [hidden]="true"
      field="baseAmount"
      title="{{ 'baseAmount' | translate}}"
      [width]="wEGrid.totalPrice"
      [minResizableWidth]="wEGrid.totalPrice"
      >
      <ng-template
        kendoGridCellTemplate
        let-dataItem
        let-rowIndex="rowIndex"
        let-column="column"
        >
        <kendo-numerictextbox
          [spinners]="false"
          [readonly]="true"
          format="#.##"
          [decimals]="2"
          [formControl]="getFormControl(dataItem, column.field)"
        ></kendo-numerictextbox>
      </ng-template>
      <ng-template kendoGridFooterTemplate>
        <div class="numeric-column-footer">
          <app-currency-total
            [highlight]="isNotBalanced"
            [totalAmount]="totalBaseAmount"
          ></app-currency-total>
        </div>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column
      field="tax"
      title="{{ 'tax' | translate}}"
      [width]="wEGrid.tax"
      [minResizableWidth]="wEGrid.tax"
      >
      <ng-template
        kendoGridCellTemplate
        let-dataItem
        let-rowIndex="rowIndex"
        let-column="column"
        >
        <app-tax-dropdown
          [isInChildForm]="true"
          [loadTaxesFromParent]="true"
          [data]="taxesAll"
          [parentForm]="parentForm"
          [controlName]="getFormControl(dataItem, column.field)"
          (valueChange)="onTaxesValueChange()"
          >
        </app-tax-dropdown>
      </ng-template>
    </kendo-grid-column>
    @if (false) {
      <kendo-grid-column
        field="net"
        title="{{ 'net' | translate}}"
        [width]="wEGrid.totalPrice"
        [minResizableWidth]="wEGrid.totalPrice"
        >
        <ng-template
          kendoGridCellTemplate
          let-dataItem
          let-rowIndex="rowIndex"
          let-column="column"
          >
          <div>
            <kendo-numerictextbox
              [spinners]="false"
              [readonly]="true"
              [formControl]="getFormControl(dataItem, column.field)"
            ></kendo-numerictextbox>
          </div>
        </ng-template>
      </kendo-grid-column>
    }
    <kendo-grid-command-column
      title=""
      [width]="wEGrid.action"
      [resizable]="false"
      class="text-center"
      >
      <ng-template kendoGridCellTemplate let-isNew="isNew" let-dataItem>
        @if (dataItem.rowId !== gridData.length - 1) {
          <button
            kendoGridRemoveCommand
            icon="delete"
          ></button>
        }
      </ng-template>
    </kendo-grid-command-column>
  </kendo-grid>
  <div class="totals-container">
    <div class="flex justify-between">
      <span><b>{{ 'net' | translate}}</b></span>
      <app-currency-total
        [currencyUid]="parentForm.controls.currencyUid.value"
        [totalAmount]="totalAmount"
      ></app-currency-total>
    </div>
    <div class="flex justify-between">
      <span><b>{{ 'tax' | translate}}</b></span>
      <app-currency-total
        [currencyUid]="parentForm.controls.currencyUid.value"
        [totalAmount]="totalTax"
      ></app-currency-total>
    </div>
    <div class="flex justify-between">
      <span><b>{{ 'total' | translate}}</b></span>
      <app-currency-total
        [currencyUid]="parentForm.controls.currencyUid.value"
        [totalAmount]="totalAmount + totalTax"
      ></app-currency-total>
    </div>
  </div>